export default __webpack_public_path__ + "static/media/onboard.06587869.svg";